import { useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Box from "@mui/material/Box";

const Layout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 900;
      setIsMobile(mobile);
      if (!mobile) setSidebarOpen(false);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    if (isMobile) setSidebarOpen(!sidebarOpen);
    else setSidebarCollapsed(!sidebarCollapsed);
  };

  const handleMobileMenuClick = () => setSidebarOpen(true);

  const getMainContentStyle = () => ({
    marginLeft: isMobile ? 0 : undefined,
    transition: "margin-left 0.3s ease",
    width: "100%",
    minHeight: "100vh",
    background: "#f3f5fa",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: 0,
  });

  return (
    <Box sx={{ display: "flex", height: "100%", width: "100%" }}>
      <Box sx={{ width: "fit-content" }}>
        <Sidebar
          collapsed={sidebarCollapsed}
          toggleSidebar={toggleSidebar}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />
      </Box>
      <Box
        component="main"
        sx={getMainContentStyle()}
        style={{
          flex: "1 1 0%",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <div>
          <Header
            sidebarOpen={sidebarCollapsed}
            toggleSidebar={toggleSidebar}
            onMobileMenuClick={handleMobileMenuClick}
          />
        </div>
        <Box
          style={{
            width: "100%",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
